import * as React from 'react';
import { SVGProps } from 'react';

const IconLoadingSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.549 2.219c.145-.542-.177-1.106-.733-1.171a7 7 0 1 0 5.688 4.365c-.207-.521-.835-.686-1.32-.405-.486.28-.641.9-.465 1.432a4.97 4.97 0 1 1-4.433-3.402c.56.032 1.118-.278 1.263-.82Z" />
  </svg>
);
export default IconLoadingSizeS;
